import React, { useState } from "react";
import { Spinner } from "components/common";
import { useGetProcedureTitles } from "security-app/hooks/useInvestigationsAPI";
import { Col, Row } from "common/components/layout-styles";
import { Paginator } from "security-app/components/common";
function ProcedureTitlesOverlay({ invId, procedureId }) {
  const [{ page, perPage }, setPage] = useState({ page: 1, perPage: 10 });
  const { titles, loadingProcedureTitles, pagination } = useGetProcedureTitles(invId, procedureId, { page, perPage });
  const onNewPage = (newPage) => setPage((prev) => ({ ...prev, page: newPage }));
  if (loadingProcedureTitles) return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading procedure titles" });
  return /* @__PURE__ */ React.createElement(Col, { $gap: "md" }, /* @__PURE__ */ React.createElement(Col, { $gap: "xs" }, titles.map((title) => /* @__PURE__ */ React.createElement(Row, { key: title }, title))), /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "flex-end" }, /* @__PURE__ */ React.createElement(
    Paginator,
    {
      currentPage: page,
      totalItems: pagination.grandTotal,
      itemsPerPage: pagination.perPage,
      onNewPage
    }
  )));
}
export default ProcedureTitlesOverlay;
